<template>
  <div class="purchase-order-material-select hmd-btn">
    <a-button :disabled="!repoId" type="primary" @click="showModal">选择库存材料</a-button>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { StoreMaterialListRecord } from "./store-material-interface";
import MaterialTable from "./material-table/index.vue";
import SelectedTable from "./selected-table/index.vue";
import { hmdConfirm } from "@/dialog/index";
/**
 * 库存材料选择
 */
export default defineComponent({
  name: "StoreMaterialSelect",
  components: { MaterialTable, SelectedTable },
  props: {
    repoId: { type: String, required: true },
    companyId: { type: String, default: "" },

    value: { type: Array as PropType<string[]>, default: () => [] },
  },
  emits: ["update:value", "change"],
  setup(props, { attrs, slots, emit }) {
    const state = reactive<{
      visible: boolean;
      currentMaterialList: StoreMaterialListRecord[];
    }>({
      visible: false,
      currentMaterialList: [],
    });

    const showModal = () => {
      hmdConfirm({
        com: import("./dialog.vue"),
        params: {
          repoId:props.repoId,
          companyId:props.companyId,
          value:props.value
        },
        confirm:({res})=>{
          let {ids,currentMaterialList}=res
          emit("update:value", ids);
          emit("change", currentMaterialList);
        }
      });
    };

    return {
      ...toRefs(state),
      showModal
    };
  },
});
</script>

<style lang="less" scoped>
.purchase-order-material-select {
  display: inline-block;
}
</style>

<style lang="less">
.purchase-order-material-select__modal {
  position: relative;
  padding: 0 500px 0 0;//修改右侧列表宽度 YF-113725
  min-height: 500px;

  &__right {
    position: absolute;
    top: 0;
    height: 100%;
    overflow-y: auto;
  }

  &__right {
    right: 0;
    width: 485px;//修改右侧列表宽度 YF-113725
  }
}
</style>
